import React from 'react';
import { Button, Modal } from 'antd';

interface DeleteConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
  message: string;
}

interface SessionExpirationModalProps {
  visible: boolean;
  onLogin: () => void;
}

export function DeleteConfirmationModal({
  visible,
  onConfirm,
  onCancel,
  loading,
  message,
}: DeleteConfirmationModalProps): JSX.Element {
  return (
    <Modal
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      footer={[
        <Button key='cancel' onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key='ok' type='primary' onClick={onConfirm} loading={loading}>
          Confirm
        </Button>,
      ]}
    >
      <p>{message}</p>
    </Modal>
  );
}

export function SessionExpirationModal({
  visible,
  onLogin,
}: SessionExpirationModalProps): JSX.Element {
  return (
    <Modal
      title='Session Expired'
      open={visible}
      closable={false}
      footer={[
        <Button key='reload' type='primary' onClick={onLogin}>
          Sign In
        </Button>,
      ]}
    >
      <p>Your session has expired. Please sign in again.</p>
    </Modal>
  );
}
